import { Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';
import { ISymbol } from '../../shared/models/symbol.model';
import { Category } from '..';

@Injectable({
	providedIn: 'root'
})
export class MarketWatchOverlayManagerService {
	public symbolSub = new BehaviorSubject<ISymbol>(undefined);
	public symbolObs$ = this.symbolSub.asObservable().pipe(filter(Boolean));

	public categorySub = new BehaviorSubject<Category>(undefined);
	public categoryObs$ = this.categorySub.asObservable().pipe(filter(Boolean));

	public showCategoryOverlaySub = new BehaviorSubject<boolean>(false);
	public showCategoryOverlayObs$ = this.showCategoryOverlaySub.asObservable();

	public showSymbolOverlaySub = new BehaviorSubject<boolean>(false);
	public showSymbolOverlayObs$ = this.showSymbolOverlaySub.asObservable();

	public showNewCatSectionSub = new BehaviorSubject<boolean>(false);
	public showNewCatSectionObs$ = this.showNewCatSectionSub.asObservable();

	// selectedStock: ISearchSymbol | ISymbolWithCategory;

	// private _selectedCategory: Category;
	// get selectedCategory(): Category {
	// 	return this._selectedCategory;
	// }

	// set selectedCategory(value: Category) {
	// 	this._selectedCategory = value;
	// }

	// private updateAddToWatchSub: Subject<boolean> = new Subject<boolean>();
	// updateAddToWatch$: Observable<boolean> = this.updateAddToWatchSub.asObservable();

	// private openAddToWatchSub: Subject<boolean> = new Subject<boolean>();
	// openAddToWatch$: Observable<boolean> = this.openAddToWatchSub.asObservable();

	// private openAddToWatchWithSearchSub: Subject<boolean> = new Subject<boolean>();
	// openAddToWatchWithSearch$: Observable<boolean> = this.openAddToWatchWithSearchSub.asObservable();

	// activeWatchPanel = false;
	// activeWatchWithSearchPanel = false;

	// toggleWatch(state: boolean) {
	// 	this.activeWatchPanel = state;
	// 	this.openAddToWatchSub.next(state);
	// }

	// toggleWatchWithSearch(state: boolean) {
	// 	this.activeWatchWithSearchPanel = state;
	// 	this.openAddToWatchWithSearchSub.next(state);
	// }

	// updateAddToWatch() {
	// 	this.updateAddToWatchSub.next(true);
	// }
}
